import { GetStaticPropsContext } from 'next';

import { DEFAULT_LANGUAGE } from '~/features/internationalization/languages';
import { PageHead } from '~/features/page/components/page-head';
import { PageLayout } from '~/features/page/components/page-layout';
import { getPage } from '~/features/page/controllers/get-page';
import { Page } from '~/features/page/models/page';
import { getPageTemplate } from '~/features/page-template/controllers/get-page-template';
import { GovernmentOverview } from '~/features/page-template/templates/government-overview/components/government-overview';
import {
  GovernmentOverviewTemplate,
  governmentOverviewTemplateQuery,
  governmentOverviewTemplatesSchema,
} from '~/features/page-template/templates/government-overview/model';

export default function GovernmentOverviewPage({
  page,
  governmentOverviewTemplate,
}: {
  page: Page;
  governmentOverviewTemplate: GovernmentOverviewTemplate;
}) {
  return (
    <>
      <PageHead page={page} />
      <PageLayout withoutVerticalPadding>
        <GovernmentOverview pageTemplateData={governmentOverviewTemplate} />
      </PageLayout>
    </>
  );
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  // Stop additional locale pages except the default locale from being built
  if (locale !== DEFAULT_LANGUAGE) {
    return {
      notFound: true,
    };
  }

  const [page, governmentOverviewTemplate] = await Promise.all([
    getPage('/government/overview'),
    getPageTemplate<GovernmentOverviewTemplate>({
      templateName: 'Government Overview Template',
      templateQuery: governmentOverviewTemplateQuery,
      templateZodSchema: governmentOverviewTemplatesSchema,
    }),
  ]);

  return {
    props: {
      page,
      governmentOverviewTemplate,
    },
  };
}
